Ext.define('SA.DefaultDatasetLimit', {
    constructor(data) {
        this.datasetName = data.datasetName;
        this.proposedUse = data.proposedUse;

        this.perWeek = new SA.DefaultLimitInterval(data.perWeek);
        this.perYear = new SA.DefaultLimitInterval(data.perYear);
    },

    isBeyondLimit() {
        return this.isBeyondPerWeekLimit() || this.isBeyondPerYearLimit();
    },

    isBeyondPerWeekLimit() {
        return this.perWeek.isBeyondLimit();
    },

    isBeyondPerYearLimit() {
        return this.perYear.isBeyondLimit();
    },

    serialize() {
        var datasetName = this.datasetName,
            proposedUse = this.proposedUse,
            perWeek = this.perWeek.serialize(),
            perYear = this.perYear.serialize();

        return {datasetName, proposedUse, perWeek, perYear};
    }
});